import { productCarouselProductStyles } from "@insite/content-library/Components/ProductCarouselProduct";
import { productImageStyles } from "@insite/content-library/Components/ProductImage";
import { productCarouselStyles } from "@insite/content-library/Widgets/Common/ProductCarousel";
import { css } from "styled-components";

// The `titleText` property is initially defined by Insite but can be set to null by extensions.
productCarouselStyles.titleText!.italic = true;


productImageStyles.linkWrappingImage = {
    css: css`
        width: 100%;
        height: 210px;
    `,
};

productImageStyles.img = {
    css: css`
        height: auto;
        max-height: 100%;
        width: 100%;
    `,
};

productCarouselProductStyles.productPartNumbersStyles = {
    container: {
        css: css`
            flex-grow: 0;
            margin-bottom: 6px;
        `,
    },
    erpNumberGridItem: {
        css: css`
            flex-direction: column;
        `,
    },
    erpNumberLabelText: { size: 13 },
    erpNumberValueText: { size: 13 },
};

productCarouselProductStyles.productDescriptionStyles = {
    productDetailLink: {
        css: css`
            margin-bottom: 6px;
            font-size: 13px;
        `,
    },
};

productCarouselProductStyles.productPriceWrapper = {
    css: css`
        flex-grow: 1;
        margin-bottom: 20px;
    `,
};